import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const browserHistoryStore = create(
  persist(
    (set, get) => ({
      history: [],
      add: async (url) => {
        set((state) => {
          if (state.history.length >= 10) {
            return {
              ...state,
              history: [
                ...state.history.slice(
                  state.history.length - 9,
                  state.history.length
                ),
                url,
              ],
            };
          } else {
            return { ...state, history: state.history.concat(url) };
          }
        });
      },
      clear: async () => {
        set((state) => ({ ...state, history: [] }));
      },
    }),
    {
      name: "browserhistory-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default browserHistoryStore;
